'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

var _profile = require('redux/modules/profile');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var YES = 'Yes';
var NO = 'No';

var FirstTimeLogin = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    profile: state.profile.data
  };
}, { updateProfile: _profile.update }), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(FirstTimeLogin, _Component);

  function FirstTimeLogin() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, FirstTimeLogin);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FirstTimeLogin.__proto__ || (0, _getPrototypeOf2.default)(FirstTimeLogin)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      completedSurveyTime: '', // Have you completed online the Reboot Kids Survey Time 0
      eatingSurvey: '', // Australian Child and Adolescent Eating Survey
      dietaryRecall: '',
      showModal: !_this.props.profile.hasFinishedIntro
    }, _this.handleChange = function (str, event) {
      var obj = _this.state;
      obj[str] = event.target.value;
      _this.setState(obj);
    }, _this.close = function () {
      var obj = _this.state;
      obj.showModal = false;
      _this.setState(obj);
    }, _this.submit = function () {
      var obj = _this.state;
      obj.showModal = false;
      _this.setState(obj);

      if (_this.state.completedSurveyTime === YES && _this.state.eatingSurvey === YES && _this.state.dietaryRecall === YES) {
        _this.props.updateProfile(_this.props.user.userId, { 'hasFinishedIntro': true });
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  /* ****************************** */
  /* HANDLE FORM CHANGE FUNCTIONS   */
  /* ****************************** */

  // without handleChange, form value fields would not change on the front end


  (0, _createClass3.default)(FirstTimeLogin, [{
    key: 'render',
    value: function render() {
      var styles = require('./Profile.scss');
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          ReactBootstrap.Modal,
          { show: this.state.showModal, onHide: this.close },
          _react2.default.createElement(
            ReactBootstrap.Modal.Header,
            { closeButton: true },
            _react2.default.createElement(
              ReactBootstrap.Modal.Title,
              null,
              _react2.default.createElement(
                'h3',
                { className: styles.orangeText },
                'Welcome to Reboot Kids!'
              )
            )
          ),
          _react2.default.createElement(
            ReactBootstrap.Modal.Body,
            null,
            _react2.default.createElement(
              'p',
              null,
              'We just need to check some details before we get started.'
            ),
            _react2.default.createElement(
              'h4',
              null,
              'Have you completed online the:'
            ),
            _react2.default.createElement(
              'h5',
              null,
              'Reboot Kids Survey Time 0'
            ),
            _react2.default.createElement(
              ReactBootstrap.FormGroup,
              { onChange: this.handleChange.bind(this, 'completedSurveyTime') },
              _react2.default.createElement(
                ReactBootstrap.Radio,
                { name: 'completedSurveyTime', value: YES, checked: this.state.completedSurveyTime === YES },
                YES
              ),
              _react2.default.createElement(
                ReactBootstrap.Radio,
                { name: 'completedSurveyTime', value: NO, checked: this.state.completedSurveyTime === NO },
                NO
              )
            ),
            _react2.default.createElement(
              'h5',
              null,
              'Australian Child and Adolescent Eating Survey'
            ),
            _react2.default.createElement(
              ReactBootstrap.FormGroup,
              { onChange: this.handleChange.bind(this, 'eatingSurvey') },
              _react2.default.createElement(
                ReactBootstrap.Radio,
                { name: 'eatingSurvey', value: YES, checked: this.state.eatingSurvey === YES },
                YES
              ),
              _react2.default.createElement(
                ReactBootstrap.Radio,
                { name: 'eatingSurvey', value: NO, checked: this.state.eatingSurvey === NO },
                NO
              )
            ),
            _react2.default.createElement(
              'h5',
              null,
              'Have you completed over the phone, a 24 hour dietary recall?'
            ),
            _react2.default.createElement(
              ReactBootstrap.FormGroup,
              { onChange: this.handleChange.bind(this, 'dietaryRecall') },
              _react2.default.createElement(
                ReactBootstrap.Radio,
                { name: 'dietaryRecall', value: YES, checked: this.state.dietaryRecall === YES },
                YES
              ),
              _react2.default.createElement(
                ReactBootstrap.Radio,
                { name: 'dietaryRecall', value: NO, checked: this.state.dietaryRecall === NO },
                NO
              )
            ),
            (this.state.completedSurveyTime === NO || this.state.eatingSurvey === NO || this.state.dietaryRecall === NO) && _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'p',
                null,
                'Please contact the Reboot Kids RCT study co-ordinator at ',
                _react2.default.createElement(
                  'strong',
                  { className: styles.orangeText },
                  'reboot@unsw.edu.au '
                ),
                'before continuing the program.'
              )
            )
          ),
          _react2.default.createElement(
            ReactBootstrap.Modal.Footer,
            null,
            _react2.default.createElement(
              ReactBootstrap.Button,
              { className: 'btn-success', onClick: this.submit },
              'Save and submit'
            )
          )
        )
      );
    }
  }]);
  return FirstTimeLogin;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object,
  profile: _propTypes2.default.object,
  updateProfile: _propTypes2.default.func
}, _temp2)) || _class);
exports.default = FirstTimeLogin;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Profile/FirstTimeLogin.js
// module id = 1223
// module chunks = 0